import client from './ApiClient';

function getPerformancePreSignUrl(query) {
  return client(`v1/uploads/presign`, { params: query });
}

export { getPerformancePreSignUrl };
